<template>
  <div
    :class="[
      'tags-item',
      'columns',
      'is-mobile',
      'is-gapless',
      'is-vcentered',
      { 'tags-item--selected': isSelected },
    ]"
  >
    <h3 class="tags-item__name">{{ nameFormatted }}</h3>
    <p class="tags-item__count">{{ count }}</p>
  </div>
</template>

<script>
import { GETTER } from '@/store/CONSTANTS';

export default {
  name: 'TagsItem',
  props: {
    name: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    nameFormatted() {
      return this.$t(`DASHBOARD.TAGS.${this.name?.toUpperCase()}`);
    },
    isSelected() {
      return this.$store.getters[GETTER.DASHBOARD.SELECTED_TAG]?.name === this.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.tags-item {
  height: 56px;
  width: 368px;
  color: $white;
  background-color: $primary-color;
  margin-right: $sp-m;
  padding: $sp-s + $sp-xs $sp-m $sp-s + $sp-xs;
  border-radius: 8px;
  cursor: pointer;

  @include for('mobile-only') {
    height: 40px;
    width: fit-content;
    color: $primary-color;
    background-color: $white;
    margin-right: $sp-s;
    padding: $sp-s $sp-s $sp-s $sp-s + $sp-xs;
    border: 1.4px solid $primary-color;

    &--selected {
      border: none;
      color: $white;
      background-color: $primary-color;
    }
  }

  @include for('desktop-wide') {
    width: 432px;
    margin-right: $sp-l + $sp-s;
  }

  &__name {
    @include font('DS-200');
    font-weight: 700;
    margin-right: $sp-s + $sp-xs;

    @include for('mobile-only') {
      @include font('DS-100');
      font-weight: 600;
      margin-right: $sp-s;
    }
  }

  &__count {
    @include font('DS-200');
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    background-color: rgba($white, 0.2);

    @include for('mobile-only') {
      @include font('DS-90');
      font-weight: 600;
      width: 24px;
      height: 24px;
      border-radius: 12px;
      background-color: rgba($primary-color, 0.2);

      @at-root .tags-item--selected #{&} {
        background-color: rgba($white, 0.2);
      }
    }
  }

  &.is-gapless {
    margin-bottom: 0;
  }
}
</style>
